import React, { useMemo } from 'react';
import { Button } from 'antd';
import moment from 'moment';
import { BannerListEmpty } from 'common/components/svgs';
import ListItem from '../list-item';
import ListSkeleton from './list-skeleton';

export default function BannerList({
  t,
  list,
  deleteBanner,
  loading,
  addBanner,
  cityName,
  setCurrentBannerId,
  adjustBannerPositions,
}) {
  const headerConfig = ['Image', 'Link', 'Effective date', 'Apply to', 'Latest update', 'Action'];
  const displayBannerIds = useMemo(() => {
    return list
      .filter(item => moment().isBetween(item.effectiveStartDate, item.effectiveEndDate))
      .slice(0, 3);
  }, [list]);

  return (
    <div className="banner-list-container">
      <If condition={list.length !== 0 || loading}>
        <div className="list-header">
          {headerConfig.map(config => (
            <div className="header-item" key={config}>
              {config}
            </div>
          ))}
        </div>
      </If>
      {loading ? (
        <>
          <ListSkeleton />
          <ListSkeleton />
          <ListSkeleton />
          <ListSkeleton />
          <ListSkeleton />
        </>
      ) : (
        list.map((listItem, index) => (
          <ListItem
            itemData={listItem}
            key={index}
            currentIndex={index}
            t={t}
            deleteBanner={deleteBanner}
            editBanner={addBanner}
            setCurrentBannerId={setCurrentBannerId}
            cityName={cityName}
            adjustBannerPositions={adjustBannerPositions}
            preBannerId={index !== 0 ? list[index - 1].id : null}
            displayBannerIds={displayBannerIds}
          />
        ))
      )}
      <If condition={list.length === 0}>
        <div className="empty-container">
          <BannerListEmpty className="empty-icon" />
          <span className="empty-desc">{`You haven't added any banners yet.`}</span>
          <Button
            icon="plus"
            type="primary"
            className="empty-button"
            onClick={() => {
              setCurrentBannerId(null);
              addBanner();
            }}
          >
            Add new banner
          </Button>
        </div>
      </If>
    </div>
  );
}
